import { Component, Input, OnInit } from '@angular/core';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-modal-emprestimo',
  templateUrl: './modal-emprestimo.component.html',
  styleUrls: ['./modal-emprestimo.component.css']
})
export class ModalEmprestimoComponent implements OnInit {
  //ICONES
  faExclamation = faExclamation;
  //VARIAVEIS
  @Input() emprestimo: any;
  itensPorPagina = 5;
  listaEmprestimoDetalhado: Array<any> = [];
  paginaAtual = 1;
  constructor(private modalService: NgbModal, public activeModal: NgbActiveModal) { }
  ngOnInit(): void {
    this.listaEmprestimoDetalhado = this.emprestimo?.parcel;
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.itensPorPagina = quantidade;
    this.getItensDaPagina();
  }
  getItensDaPagina(): any[] {
    const startIndex = (this.paginaAtual - 1) * this.itensPorPagina;
    const endIndex = startIndex + this.itensPorPagina;
    return this.listaEmprestimoDetalhado.slice(startIndex, endIndex);
  }
}
